import { call, PATH} from "../managers/network";

export function getMonitors(){
  return call({
    method:'GET',
    path: PATH.monitors
  })
}

export function createAMonitor(){
  return call({
    method:'GET',
    path: PATH.monitors
  })
}


export function getMyProfile(){
  return call({
    method:'GET',
    path: PATH.myProfile
  })
}


